export const config = {
  title: "Ultra Rays Window Cleaning | Camp Verde, AZ",
  meta: {
    description:
      "Ultra Rays Window Cleaning provides professional residential and commercial window cleaning services in Camp Verde, AZ and surrounding areas. We ensure spotless, streak-free windows every time.",
    keywords: [
      "Ultra Rays Window Cleaning",
      "Window Cleaning Camp Verde",
      "Residential Window Cleaning",
      "Commercial Window Cleaning",
      "Arizona Window Services",
    ],
    author: "Ultra Rays Window Cleaning",
    canonicalUrl: "https://ultrarayswindowcleaning.com/",
  },
  sections: {
    header: {
      businessName: "Ultra Rays Window Cleaning",
    },
    sectionB: {
      heroTitle: "Spotless Windows, Guaranteed",
      heroSubtitle: "Professional Window Cleaning in Camp Verde, AZ",
      learnAboutText: "Request a Free Estimate",
      phoneNumber: "9282749417",
      phoneLabel: "(928) 274-9417",
      heroBackgroundImage:
        "https://media.istockphoto.com/id/504403109/photo/clear-blue-sky.jpg?s=612x612&w=0&k=20&c=b01oacaCHIax0jcdp_8TLfd76VbcKn7e6Pdp_RniIdo=",
      cardData: [
        {
          title: "Residential Cleaning",
          description:
            "Crystal-clear windows that brighten your home and enhance curb appeal.",
        },
        {
          title: "Commercial Cleaning",
          description:
            "Maintain a professional look for your business with streak-free, polished windows.",
        },
        {
          title: "Reliable Service",
          description:
            "Dedicated to quality and customer satisfaction with every job.",
        },
      ],
      description:
        "Ultra Rays Window Cleaning offers top-notch window cleaning services for both residential and commercial clients in Camp Verde, AZ and nearby areas.",
    },
    sectionC: {
      servicesTitle: "Our Services",
      servicesDescription:
        "From small homes to large commercial spaces, we provide thorough and reliable window cleaning solutions.",
      cards: [
        {
          title: "Residential Window Cleaning",
          description:
            "Keep your home looking its best with our detailed window cleaning services.",
          imageSrc: "https://media.istockphoto.com/id/2171662003/photo/unrecognisable-woman-cleaning-windows-of-country-house.jpg?s=612x612&w=0&k=20&c=selzNIfrRVVSciROUarpSYXyTEaQ8EwXUI2LJrpDmz4=",
          imageAlt: "Residential Window Cleaning",
        },
        {
          title: "Commercial Window Cleaning",
          description:
            "Enhance your business image with sparkling, streak-free windows.",
          imageSrc: "https://media.istockphoto.com/id/162353089/photo/window-cleaning.jpg?s=612x612&w=0&k=20&c=HUXLEt9RI6Jr3ZxVU54K-k6rvcCIZZrPww7pUi2ow9g=",
          imageAlt: "Commercial Window Cleaning",
        },
        {
          title: "Screen & Track Cleaning",
          description:
            "We go beyond glass cleaning to ensure screens and tracks are spotless too.",
            imageSrc: "https://media.istockphoto.com/id/2188382661/photo/worker-on-a-cherry-picker-cleaning-a-roof-windows-with-high-pressure-water-jet.jpg?s=612x612&w=0&k=20&c=VD96Khel5LyLd7funwDiIo9XWRYQ6G_80-hyN_4tNxM=",
            imageAlt: "Screen and Track Cleaning",
        },
      ],
      otherServicesTitle: "Other Services",
      otherServicesList: [
        "Glass Door Cleaning",
        "Hard Water Stain Removal",
        "Interior & Exterior Windows",
        "Custom Cleaning Packages",
      ],
    },
    sectionD: {
      aboutTitle: "About Ultra Rays Window Cleaning",
      aboutImage: {
        src: "https://media.istockphoto.com/id/181735112/photo/housework-and-squeegee-for-glass.jpg?s=612x612&w=0&k=20&c=RwJ6cuI1URzaNDZDmhwyjPDsIgMigzenom9a6hy6ji8=",
        alt: "Ultra Rays Window Cleaning Team",
      },
      aboutText: [
        "At Ultra Rays Window Cleaning, we are passionate about providing spotless windows and unmatched customer service.",
        "Based in Camp Verde, AZ, we proudly serve homeowners and businesses with reliable, professional, and affordable window cleaning solutions.",
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: "Ultra Rays Window Cleaning Logo",
      businessName: "Ultra Rays Window Cleaning",
      contact: {
        phone: "9282749417",
        phoneLabel: "(928) 274-9417",
        email: "garchr4@gmail.com",
        website: "https://ultrarayswindowcleaning.com/",
        address: "3173 Cherry Ln, Camp Verde, AZ 86322",
      },
      socialMedia: {},
    },
    sectionF: {
      address: "3173 Cherry Ln, Camp Verde, AZ 86322",
      googleMapsEmbedUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3310.300000000000!2d-111.857000!3d34.563600!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x872da1c5abcd123%3A0xabcdef123456789!2s3173%20Cherry%20Ln%2C%20Camp%20Verde%2C%20AZ%2086322!5e0!3m2!1sen!2sus!4v1730400000000!5m2!1sen!2sus",
    },
  },
};

export default config;
